type ErrorMessage = {
  title: string;
  message: string;
};

type ErrorMessages = {
  RATE_LIMITED: ErrorMessage;
  GENERIC: ErrorMessage;
};

export const ERROR_MESSAGES: ErrorMessages = {
  RATE_LIMITED: {
    title: 'You’ve exceeded the request limit',
    message: 'Please wait a minute, then try again.'
  },
  GENERIC: {
    title: 'Template analysis failed',
    message: 'Please try again.\n\nIf your action continues to fail, please contact support.'
  }
};

export const AiTrackedEventCategories = {
  AIFields: 'AIFields'
};
